import { geometricPatterns } from './geometricPatterns';

// Mock data for portfolio

export const personalInfo = {
  name: "Abner Pallichan",
  role: "Security Systems Estimator & Project Engineer",
  djName: "Abner",
  tagline: "Engineering by Day, Moving Crowds by Night",
  location: "London, United Kingdom",
  email: "abnerpallichan@gmail.com",
  bio: "Security Systems Estimator and Project Engineer with over 3 years of experience specializing in delivering cost plans, take-offs, and technical documentation for access control, nurse call, and electrical systems across healthcare and commercial projects.",
  djBio: "Underground DJ and event curator pushing the boundaries of garage, techno, and house music across London's vibrant electronic scene.",
  experience: "3+ Years",
  projectsCompleted: "25+",
  specialization: "Healthcare & Security Systems",
  soundcloud: "https://soundcloud.com/nbrae",
  festa: "https://festa.london/"
};

export const festaInfo = {
  name: "Festa",
  tagline: "london underground garage, techno & house",
  description: "A new collective bringing the best underground electronic sounds to london.",
  website: "https://festa.london/",
  genres: ["Garage", "Techno", "House"],
  nextEvent: {
    date: "FRI 24 APR 2026",
    time: "21:00",
    venue: "HWK",
    location: "29 White Post Ln, London E9 5EN",
    ticketUrl: "https://ra.co/events/2415993"
  }
};

export const experience = [
  {
    id: 1,
    role: "Project Manager / Estimator",
    company: "Hills Health Solutions",
    location: "Melbourne, Australia",
    period: "Sept 2024 – May 2025",
    description: "Prepared detailed cost estimates and proposals for nurse call and healthcare security systems across hospital and aged care facilities. Conducted site surveys, reviewed technical drawings, and produced accurate take-offs, BOQs, and procurement schedules.",
    achievements: [
      "Integrated CAD outputs into commercial submissions",
      "Maintained profitability and commercial control",
      "Liaised with clients, suppliers, and installation teams"
    ]
  },
  {
    id: 2,
    role: "Project Coordinator / Estimator",
    company: "Austco",
    location: "Melbourne, Australia",
    period: "Jul 2023 – Sept 2024",
    description: "Produced high-volume material take-offs and cost plans from AutoCAD and Bluebeam for access control and electrical systems. Estimated security infrastructure including card readers, cabling routes, control panels, and door hardware.",
    achievements: [
      "Developed standardized CAD templates and workflows",
      "Prepared tender documentation and pricing schedules",
      "Acted as technical interface between stakeholders"
    ]
  },
  {
    id: 3,
    role: "Project Engineer",
    company: "Teknocorp",
    location: "Melbourne, Australia",
    period: "Aug 2022 – Jul 2023",
    description: "Produced technical drawings and installation schematics for security and access control packages using AutoCAD and Revit. Updated as-built documentation to reflect site conditions and system changes.",
    achievements: [
      "Supported commercial teams with design revisions",
      "Assisted with project handovers and compliance documentation",
      "Created system layouts and pricing inputs"
    ]
  }
];

export const skills = {
  estimating: [
    "Take-offs & BOQs",
    "Tender Submissions",
    "Cost Plans",
    "Subcontractor Pricing",
    "Risk Identification",
    "Proposal Writing"
  ],
  systems: [
    "Access Control Systems",
    "Nurse Call Systems",
    "Healthcare Systems",
    "Electrical Infrastructure",
    "Low-Voltage Systems",
    "Security Systems"
  ],
  software: [
    "AutoCAD",
    "Revit",
    "Civil 3D",
    "Bluebeam",
    "Planswift",
    "SimPro",
    "Microsoft Office",
    "Adobe Creative Suite"
  ],
  professional: [
    "Client Communication",
    "Stakeholder Management",
    "Technical Documentation",
    "Project Coordination",
    "Time Management",
    "Multi-project Management"
  ],
  djSkills: [
    "Vinyl Selection",
    "Crowd Reading",
    "Mixing & Transitions",
    "Event Curation",
    "Underground Networks",
    "Sound Engineering"
  ]
};

export const projects = [
  {
    id: 1,
    title: "Northern Hospital Upgrade",
    company: "Teknocorp",
    location: "Epping, Victoria",
    type: "Healthcare",
    category: ["Healthcare", "Security"],
    description: "Comprehensive nurse call and security system upgrade for Northern Hospital. Delivered complete technical drawings, installation schematics, and as-built documentation for modern healthcare communication infrastructure.",
    scope: "Nurse Call & Security Systems",
    year: "2023"
  },
  {
    id: 2,
    title: "Mt Eliza Aged Facility",
    company: "Teknocorp",
    location: "Mt Eliza, Victoria",
    type: "Aged Care",
    category: ["Aged Care", "Security"],
    description: "Complete nurse call and security fitout for aged care facility. Designed integrated systems for resident safety, staff communication, and facility security with focus on accessibility and reliability.",
    scope: "Nurse Call & Security Fitouts",
    year: "2023"
  },
  {
    id: 3,
    title: "FRV Fire Stations",
    company: "Teknocorp",
    location: "Victoria-wide",
    type: "Commercial",
    category: ["Security"],
    description: "Security system fitouts across multiple Fire Rescue Victoria stations throughout the state. Standardized security infrastructure design and implementation for critical emergency service facilities.",
    scope: "Security Fitouts",
    year: "2022-2023"
  },
  {
    id: 4,
    title: "Geelong Stadium",
    company: "Teknocorp",
    location: "Geelong, Victoria",
    type: "Commercial",
    category: ["Security"],
    description: "Large-scale security fitout for major sporting venue. Comprehensive access control, CCTV integration, and perimeter security systems designed for high-capacity public facility.",
    scope: "Security Fitout",
    year: "2023"
  },
  {
    id: 5,
    title: "Summerset Aged Care",
    company: "Teknocorp",
    location: "Victoria",
    type: "Aged Care",
    category: ["Aged Care", "Security"],
    description: "Security system design and implementation for aged care residential facility. Focus on resident safety, emergency response systems, and secure access management.",
    scope: "Security Systems",
    year: "2023"
  },
  {
    id: 6,
    title: "Footscray Hospital",
    company: "Hills Health Solutions",
    location: "Footscray, Victoria",
    type: "Healthcare",
    category: ["Healthcare"],
    description: "Comprehensive nurse call system fitout for major metropolitan hospital. Prepared detailed cost estimates, conducted site surveys, and delivered complete procurement schedules for healthcare communication infrastructure.",
    scope: "Nurse Call Fitout",
    year: "2024-2025"
  },
  {
    id: 7,
    title: "Epworth Private Hospital",
    company: "Hills Health Solutions",
    location: "Melbourne, Victoria",
    type: "Healthcare",
    category: ["Healthcare"],
    description: "Nurse call system upgrade for premium private hospital. Integrated CAD outputs into commercial submissions, ensuring compliance with healthcare standards and patient care requirements.",
    scope: "Nurse Call Fitout",
    year: "2024-2025"
  },
  {
    id: 8,
    title: "Alfred Hospital",
    company: "Hills Health Solutions",
    location: "Melbourne, Victoria",
    type: "Healthcare",
    category: ["Healthcare"],
    description: "Major nurse call system implementation for one of Victoria's leading hospitals. Managed complete estimating workflow from take-offs to tender submission for critical healthcare infrastructure.",
    scope: "Nurse Call Fitout",
    year: "2024-2025"
  },
  {
    id: 9,
    title: "Ballarat Base Hospital",
    company: "Hills Health Solutions",
    location: "Ballarat, Victoria",
    type: "Healthcare",
    category: ["Healthcare"],
    description: "Regional hospital healthcare systems project. Delivered comprehensive cost plans and technical documentation for nurse call infrastructure serving regional healthcare community.",
    scope: "Healthcare Systems",
    year: "2024-2025"
  },
  {
    id: 10,
    title: "Wodonga Private Hospital",
    company: "Hills Health Solutions",
    location: "Wodonga, Victoria",
    type: "Healthcare",
    category: ["Healthcare"],
    description: "Private hospital nurse call and communication systems. Conducted site surveys, liaised with suppliers, and validated system specifications for quality patient care infrastructure.",
    scope: "Healthcare Systems",
    year: "2024-2025"
  }
];

export const education = [
  {
    degree: "Bachelor of Engineering (Civil)",
    institution: null,
    location: null,
    year: "2022"
  }
];

export const certifications = [
  {
    name: "CSCS (Construction Skills Certification Scheme) Card",
    issuer: "CSCS",
    description: "Industry-standard construction site safety and competence certification",
    year: "2023",
    location: "UK"
  },
  {
    name: "AutoCAD Certified Professional",
    issuer: "Autodesk",
    description: "Advanced proficiency in AutoCAD software for technical design and drafting",
    year: "2023",
    location: "International"
  },
  {
    name: "Revit Architecture Certified Professional",
    issuer: "Autodesk",
    description: "Expert-level certification in Revit for BIM and architectural design",
    year: "2023",
    location: "International"
  },
  {
    name: "First Aid at Work Certificate",
    issuer: "St John Ambulance / HSE Approved",
    description: "Comprehensive workplace first aid and emergency response training",
    year: "2024",
    location: "UK"
  }
];

export const interests = [
  "Music Production",
  "Language Learning",
  "Bouldering",
  "Hiking",
  "Camping"
];